// Generated by Melange

import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function LogoutForm(Props) {
  let payload = Props.payload;
  const match = React.useState(function () {
        
      });
  const setToast = match[1];
  let tmp;
  let exit = 0;
  if (payload !== undefined && !(typeof payload === "string" || payload.NAME !== "LogoutPayload")) {
    const logoutUrl = payload.VAL;
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                        kind: "default",
                        isWide: true,
                        onClick: (function (param) {
                            ((window.history.back()
                              ));
                          }),
                        children: "Отмена"
                      }),
                  JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                        kind: "primary",
                        name: "submit",
                        value: "accept",
                        type_: "button",
                        isWide: true,
                        onClick: (function (param) {
                            window.location.href = logoutUrl;
                          }),
                        children: "Выйти"
                      })
                ],
                className: "flex space-x-3 mt-4"
              }),
          className: "mt-8"
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: "Improper payload"
        });
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
              toast: match[0],
              onExpired: (function (param) {
                  Curry._1(setToast, (function (param) {
                          
                        }));
                }),
              children: JsxRuntime.jsxs(Buhta_cabinet__Box.make, {
                    title: "Выход",
                    className: "relative",
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "text-gray-medium",
                            children: "Подтвердите выход из платформы"
                          }),
                      tmp
                    ]
                  })
            });
}

const make = LogoutForm;

export {
  make ,
}
/* Buhta_cabinet__Box Not a pure module */
